import { ControlsToggleExtraContent, LayoutComponent } from "packages/lesson/dist/@types";
import config from "appConfig";

export const component: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/02/17/principle/male-hi-3000-hz.svg`,
          styles: {
            maxWidth: "80%",
          },
        },
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      text: "Play sound",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
      styles: {
        marginTop: "20px",
      },
      url: `${config.ASSETS_URL}/02/17/principle/male-hi-3000-hz.wav`,
    },
  },
];
